import { IoIosFlash } from "react-icons/io";
import { TfiWorld } from "react-icons/tfi";
import { FaFileInvoiceDollar, FaHome, FaUsers, FaBriefcase, FaPhoneAlt } from "react-icons/fa";

export const MediaSidebarData = [
  {
    title: "Home",
    path: "/",
    icon: <FaHome className="tag-icon" />,
  },
  {
    title: "About Us",
    path: "/about-us",
    icon: <FaUsers className="tag-icon" />,
  },
  {
    title: "Recent Work",
    path: "/recent-work",
    icon: <FaBriefcase className="tag-icon" />,
  },
  {
    title: "Digital Marketing",
    path: "/digital-marketing",
    icon: <IoIosFlash className="tag-icon" />,
  },
  {
    title: "Website Development",
    path: "/website",
    icon: <TfiWorld className="tag-icon" />,
  },
  {
    title: "Invoice Generator",
    path: "/invoice",
    icon: <FaFileInvoiceDollar className="tag-icon" />,
  },
  {
    title: "Contact",
    path: "/get-in-touch",
    icon: <FaPhoneAlt className="tag-icon" />,
  },
];
